import { Box, styled, ThemeContext } from '@migros/msrc-ui-kit';
import React, { useContext } from 'react';
export const FallbackImage = () => {
  const theme = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(FallbackImageContainer, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "small"
  }, /*#__PURE__*/React.createElement("svg", {
    width: "54",
    height: "48",
    viewBox: "0 0 54 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8905 47.679V20.3415L30.159 47.6925H23.652L12.123 20.3415V47.6925H0V0.321014H16.2135L27.351 27.0645L39.015 0.321014H54V47.6925H41.8905V47.679Z",
    fill: theme === null || theme === void 0 ? void 0 : theme.colors.tints.gray[90]
  })));
};
const FallbackImageContainer = styled(Box)(({
  theme
}) => ({
  /* stylelint-disable string-no-newline,unit-no-unknown */
  backgroundImage: `url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0 20L20 0H10L0 10V20Z' fill='%23${theme.colors.tints.gray[25].slice(1)}'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M20 20V10L10 20H20Z' fill='%23${theme.colors.tints.gray[25].slice(1)}'/%3E%3C/svg%3E%0A")`,
  height: '100%',
  borderRadius: theme.borderRadiuses.small
  /* stylelint-enable string-no-newline,unit-no-unknown */
}));